/**
 * COLONY TERMINAL SHELL
 *
 * Thin wrapper around existing terminal views.
 * Preserves flex layout so the real terminal fills available space.
 */

import React from "react";

interface ColonyTerminalShellProps {
  children: React.ReactNode;
  projectName?: string;
}

export function ColonyTerminalShell({ children }: ColonyTerminalShellProps) {
  return (
    <div className="flex-1 flex flex-col overflow-hidden">
      {children}
    </div>
  );
}
